export const PWA_THEME_LOCAL_STORAGE_KEY = 'PwaTheme';
